
export const en: { [key: string]: { [key: string]: string } } = {
    common: {
    register: "Register",
    login: "Login",
    noData: "No records yet",
    loading: "Loading...",
    myLink: "My link:",
    level: "Level",
    quickShare: "Quick Share",
    pepole: "People",
    travel: "Day",
    activityTitle: "Activity Description",
    deposite: "Deposit",
    sake: "Withdrawal",
    loadMore: "Load more",
    times: "times",
    bets: "Bet",
    paymentChannel: "Payment Channel",
    inprogress: "In Progress",
    ok: "OK",
    title: "365GG.COM",
    ios: "IOS",
    android: "Android",
    days: "days",
    hours: "hours",
    copied: "Copied",
    more: "More",
    NoMoreData: "No more",
    notCompleted: "Not completed",
    promotion:"Promotion",
    rechargeTotal: "Today Recharge",
    loss:"Loss",
    home:"Home",
    agente:"Agente",
    profile:"Profile",
    return:"Return",
    profit : "Win",
    history:"History",
    close:"Close",
    sliderSuccess:"Verified!",
    sliderError:"Failed! Try again",
    dragToComplete:"Drag to complete the puzzle"
},
accFund: {
    mainTitle: "Accumulation Fund",
    invest: "Invest",
    andGet: "and get",
    rewardPlan: "Reward Plan",
    time: "Time",
    amountReceived: "Amount Received",
    gameFlow: "Game Flow",
    title: "Technology is nothing more than the common soul of those who develop it.",
},
bauDoTesouro: {
    treasure: "Treasure Chest",
    myReports: "My Direct Subordinates"
},
agent: {
    validBets: "Valid Bets",
    lowerLevelTeam: "Lower-Level Team",
    rollover: "Rollover",
    commission: "Commission",
    faqTitle1: "What is the affiliate program?",
    faqTitle2: "HOW MUCH DOES IT COST TO JOIN?",
    faqTitle3: "Can I get benefits even if I don't have a website?",
    faqTitle4: "HOW MUCH DO I EARN?",
    faqContent1: "Affiliates is a program where we offer you the opportunity to earn money every day, simply by helping us get more players.",
    faqContent2: "Absolutely nothing. It’s completely free.",
    faqContent3: "Of course you can. We can provide all the marketing tools you need to promote",
    faqContent3Sub: "offline on social media or by email.",
    faqContent4: "As part of our affiliate network, you will be paid on a revenue share model. You earn over 80% commission reward.",
    definition: "Definition",
    definitionContent: "Team valid bets [num] – Total value of valid bets from referrals and contributions by your team. num – Total number of referrals and team members who contributed with valid bets.",
    graphCardTitle: "Unlimited Subordinate Development",
    graphCardContent1: "1. You will receive a different commission percentage every time a player you referred places a bet,",
    graphCardContent2: "whether they win or lose.",
    graphCardContent3: "2. The system calculates commission every 3 minutes.",
    directCommission: "Direct Commissions",
    teamCommission: "Team Commissions",
    teammRollover: "Team Rollover",
    propotion: "Proportion",
    directRegistration: "Direct Registration",
    commissionTeam: "Team Commission",
    invitation: "Invitation",
    myData: "My Data",
    faq: "FAQ",
    detailed: "Detailed",
    directRechargeCommision : "Direct Recharge Commission",
    directBettingCommission:"Direct Betting Commission",
    commissionRate:"Commission Rate",
    totalCommission:"Total Bet Register",
    directPlayer:"Direct Player"
},
    rulecard: {
    communicationRules: "Commission Calculation Rules",
    faqHead1: "C3 is powerful and also has",
    faqHead2: "/millions",
    perfoTitle1: "Total Performance 3.31M, Total Agent Bonus",
    perfoTitle2: "Subordinate Performance 180K, Contributed",
    perfoTitle3: "Other Performance 3.13M, Contributed",
    tipText1: "Contribution from B1",
    tipText2: "Other contributions from C1 and C2",
    tipText3: "Contribute to",
    tipText4: "Other contributions from C3",
    tipText5: "Contribution from B3",
    subAgentWins: "Sub-agent wins, usually",
    noProfit: "B2 has no subordinates, so no profits",
    wins: "Well done sub-agent, earned",
    exampleTitle: "Example:",
    exampleTitle2: "Therefore, the bonus is calculated as follows:",
    exampleContent: `On this website, the agent bonus is calculated based on bets. For example, if bets are between 10–200,000,
                    the corresponding bonus rate will be 70/10,000, and if the bets exceed 3,000,000, the agent bonus is
                    110/10,000. A is the website’s agent. He recruits B1, B2, and B3 as his agents, and B1 also recruits
                    C1 and C2 as his agents. B2 has no agents, and B3 has only one agent, C3. After some days, B1's own
                    effective bet is 120,000; B2's is 40,000; B3's is 20,000; C1's is 100,000; C2's is 30,000; and C3 has
                    3 million in effective bets. Then, B1’s total performance comes from 130,000 by C1 and C2, and the
                    commission rebate rate is 70/10,000; B2 has 0 subordinate performance; the commission rate is
                    110/10,000. A has 180,000 from the direct team and 3.13 million from other teams, totaling 3.31 million
                    in performance, and the corresponding commission rebate rate is 110/10,000.`,
    exampleContent2: `1. Direct Team: refers to members of the vertical development chain, collectively called the Direct Team.<br>
                    (1) B1, B2, B3 contribute to A: (120,000 + 40,000 + 20,000) x 110/10,000 = 1,980.<br>
                    (2) C1 and C2 contribute to B1: (100,000 + 30,000) x 70/10,000 = 910.<br>
                    (3) C3 contributes to B3: 3 million x 110/10,000 = 33,000.<br><br>
                    2. Other Teams: refers to members developed by subordinates, and so on, collectively called Other Teams.
                    Since this system can develop subordinates infinitely, for better understanding, this article only uses
                    a 2-level structure as an example.<br>
                    (1) From C1 and C2: Since B1’s total performance is 130,000, it only gets a rebate rate of 70/10,000,
                    whereas A's total performance is 3.31 million with a rebate rate of 110/10,000. So the rebate difference
                    between A and B1 is: 110 - 70 = 40. This difference is the part contributed by C1 and C2 to A, so
                    C1 and C2 contribute to A: (100,000 + 30,000) × 40/10,000 = 520.<br>
                    (2) Other Teams: again refers to members developed by subordinates, and so on; for simplicity,
                    this example remains at 2 levels.<br><br>
                    3. Summary:<br>
                    (1) C3 is powerful and indirectly enables A to benefit from a higher commission rebate rate.<br>
                    (2) B2 may be inactive and has no advantage without developing subordinates.<br>
                    (3) Although B3 joined relatively late and is a subordinate of A, his subordinate C3 is powerful,
                    allowing B3 to directly enjoy the highest rebate rate, and A cannot directly profit from B3's difference.
                    So who does B3's position belong to when he joins? The benefits of subordinates, regardless of their level,
                    will never be affected. They will not suffer losses due to other subordinates and their development will
                    not be restricted.<br>
                    (4) This is an absolutely fair agency model that does not always disadvantage those who join later.<br>`
},
    myDataView: {
    directCommision: "Direct Commission",
    teamCommission: "Team Commission",
    totalCommssion: "Total Commissions",
    bets: "Direct Bets",
    teamBets: "Team Bets",
    totalBets: "Total Bets",
    registration: "Direct Registration",
    teamRegistration: "Team Registration",
    totalRecords: "Total Registration",
    firstDirectCommission: "First Direct Deposit",
    teamsFirstDeposit: "Team’s First Deposit",
    totalInitialDepost: "Total Initial Deposit",
    lastMonth: "Last Month",
    thisMonth: "This Month",
    lastWeek: "Last Week",
    thisWeek: "This Week",
    yesterday: "Yesterday",
    today: "Today",
    recharge: "Direct recharge",
    totalRecharge:"Total Recharge"
},

bonus: {
    mysterybonus: "Mystery Bonus",
    registrationTime: "Registration Time:",
    totalDeposit: "Total Deposit of",
    claimTime: "The time when bonuses can be claimed:",
    depostiScope: "Deposit Range"
},

cashWheel: {
    title: "Get R$ 100 Free",
    neccessary: "Still needed ",
    makeWithdrawal: "to make the withdrawal",
    expireIn: "Expires in"
},

collect: {
    rechargedMembers: "Recharged members can claim for free.",
    maximumCachValue: "Maximum Cash Drop Value:",
    depositCollector: "Please collect it after depositing",
    remainingMaxTIme: "Max drop per time",
    perDay: "per day",
    lineText1: "1. Each cash rain session is distributed free with",
    lineText2: "2. Maximum cash rain value:",
    lineText3: "3. Recharged members can claim for free.",
    oopsText: "Oops... something went wrong"
}
,
   deposit: {
    extra: "Extra",
    bonuseRedeem: "Redeemable bonus after",
    invoicing: "billing",
    receive: "and receive",
    asaGift: "as a gift",
    valueLabel: "value",
    promotions:"Participe de promoções"
},

funds: {
    rescueFunds: "Rescue Funds",
    currentLoss: "Current Loss",
    plannedFunds: "Planned Rescue Funds",
    gameLoss: "Game Loss",
    redeemFee: "Redemption Fee",
    activityContent: `<p>1. Game Loss = Account Loss - Given Amount.<br>
                    2. Rescue Funds are calculated daily based on the chart and can be claimed the next day.<br>
                    3. If a user does not request Rescue Funds today, it is considered as forfeited.<br>
                    4. The purpose of Rescue Funds is to help users recover in the game, so a 1x turnover is required.<br>
                    5. Brazilian time 00:00 is the settlement time.</p>`
},

game: {
    games: "Games",
    warm: "Hot",
    lobby: "Lobby"
},

gameLog: {
    latestData: "Latest data from the last",
    winOrLoss: "Win or Lose",
    subText: "Please contact the agent to recharge coins and start the game",
    gameRegistration: "Game Registration"
},

giftCode: {
    exchangeReward: "Exchange Rewards",
    pasteText: "Enter / Paste the coupon redemption code",
    pasteInstructions: "*Press and hold to paste.",
    activityContent: `1. Enter the redemption code to receive the cash bonus.<br>
                    2. Bonus usage must follow the platform rules.<br>
                    3. The company reserves the right of final interpretation of this activity.`,
    insertPaste: "Enter / Paste…"
},

level: {
    currentLevel: "Current Level",
    iron: "Iron",
    gameTurnOver: "Game turnover in the last 7 days",
    bronze: "Bronze",
    talk: "Silver",
    gold: "Gold",
    platinum: "Platinum",
    diamond: "Diamond"
},

withdraw: {
    myBalance: "My Balance",
    withdrawalAmount: "Withdrawal Amount",
    valueLabel: "value",
    emailErrorText : "Please enter an email address with up to 36 characters",
    cpfErrorText : "Please enter 11 digits for CPF",
    phoneErrorText : "Please enter 11 digits without the +55 for your mobile number.",
    evpErrorText : "EVP cannot be empty",
    valueText: "Withdrawal amount",
    value:"Value",
    taxIdType:"Type of Tax ID",
    cpfIdPlaceholder:"Please enter your CPF ID…",
    emailPlaceholder: "Please enter Email ID…",
    phonePlaceholder: "Please enter PHONE ID…",
    evpPlaceholder: "Enter EVP number",
    userName:"Beneficiary's name",
    userNamePlaceholder: "Please provide the name of the beneficiary…",
    cpfPlaceholder : "Please enter your CPF…",
    brazilId :"Brazil ID",
    brazilIdPlaceholder: "Enter your Brazilian identity number",
    bank:"Bank name",
    bankPlaceholder:"Enter bank name",
    },
    weeklyCompensation: {
    the: "From",
    to: "to",
    weeklyCompensation: "Compensation for this week",
    title: "Weekly Compensation",
    profit: "Profit this week",
    distribute: "This week’s compensation will be distributed at",
    available: "Available Compensation",
    compensation: "Compensation",
    activityContent: `1. The actual amount of money lost multiplied by the cashback percentage is the cashback for that week.<br>
                    2. Weekly profits and compensations are counted independently; previous profits will not affect this week's stats.<br>
                    3. Compensation not yet claimed by the customer will continue to accumulate until it is collected.<br>
                    4. If you didn’t bet during the cashback period or if your last week's or total profits exceed your losses, you won’t receive cashback.<br>
                    5. The cashback bonus requires a 1x effective betting volume before it can be withdrawn.<br>`
},

vip: {
    title: "VIP",
    receiveBonuses: "Can receive bonuses",
    bettingValue: "Accumulated betting volume",
    betVolume: "Accumulated betting volume",
    division: "Maintain division",
    bets: "Bets",
    upgradeBonus: "Upgrade Bonus",
    weeklyBonus: "Weekly Bonus",
    monthlyBonus: "Monthly Bonus",
    maintainLevel: "Bets required to maintain level",
    reduceLevel: "Level downgrade",
    VIPIncome: "VIP Earnings",
    VIPConditions: "VIP Conditions"
},

offers: {
    promotionContent: "The promotion has not started yet. Please join this event at",
    win: "Win",
    totaling: "Totaling",
    demanding: "Requiring",
    rollover: "rollover",
    content: `1. On the promotion day, make a deposit of the specified amount and receive a big bonus.<br>
            2. Each player can only participate once and cannot join repeatedly.<br>
            3. The promotion starts every Sunday.`,
    Sunday: "Sunday",
    hours: "hours",
    minutes: "min",
    seconds: "sec",
    depositReturn: "Big Deposit Return",
    depositPopText: "Deposit R$ {recharge}, win R$ {reward}, totaling "
},

profile: {
    configuration: "Profile Settings",
    choosePhoto: "Choose New Photo",
    ContactService: "Contact Service",
    onlineService: "Online Support",
    telegram: "Telegram",
    vipBot: "VIP_688V_BOT",
    chat: "Chat",
    noteText: 'Welcome! Click "CHAT" to contact us via the customer service portal.',
    settings: "Settings",
    brandName: "My Brand Name",
    registeredAcc: "Registered Account",
    password: "Password",
    withdrawalInfo: "Withdrawal Info",
    logout: "Log Out",
    id: "ID",
    account: "Account",
    logoutCurrAcc: "Log out of the current account?",
    rememberPassword: "Please remember your login account and password to log in again.",
    toLogout: "Log Out",
    cancel: "Cancel",
    enterNickName: "Please enter a nickname",
    passwordSetUp: "Password Setup",
    enterNewPassword: "Enter new password",
    cnofirmNewPassword: "Confirm new password",
    save: "Save",
    apostate: "Required Bets",
    followVIP1: "Follow VIP1, still need to bet",
    name: "Name",
    phoneNum: "Phone Number",
    email: "Email",
    cpfId: "CPF ID",
    cnpj: "CNPJ ID",
    rapporteurs: "Reports",
    toInvite: "Invite",
    redemptionCode: "Redemption Code",
    support: "Support",
    securityCenter: "Security Center",
    goOut: "Log Out",
    treasureMsg: "Invite 1 person bonus R$ 35"
},

message: {
    message: "Message",
    noMore: "No more",
    all: "All",
    system:"System",
    deposit:"Deposit",        
    withdraw:"Withdraw",
    bonus:"Bonus",
    unread:"Unread"
},
    loginRegister: {
    enterPassword: "Please enter the password",
    alreadyAcc: "Already have an account?",
    loginNow: "Login now",
    dontHaveAcc: "Don't have an account?",
    registerNow: "Register now",
    phoneFormat: "Enter a correct phone number with 11 digits.",
    passwordForamt: "Set a password between 8 to 20 characters",
    confirmPassword: "Confirm the entered password",
    differentPassword: "Passwords do not match"
},

home: {
    transfer: "Transfer",
    gameLobby: "Game Lobby",
    latestNews: "Latest News",
    IUnderstand: "I Understand",
    partners: "Partners",
    content: `688V.COM is operated by 688V N.V, company registration number 142922, with a registered address at 
              Zuikertuintjeweg Z/N (Zuikertuin Tower) Curacao, and licensed and authorized by the government of Curacao. 
              688V.COM operates under the Master License of Gaming Services Provider, N.V. License Number: GLH-OCCHKTW065752688
              <br><br>
              1. This product is for users over 18 years old and is intended for entertainment purposes only.<br>
              2. This game contains in-app purchases.<br>
              3. Playing or winning in a social betting game does not imply future success in real money betting or related games.<br><br>`,
    copyright: "©2025 688V. All rights reserved. 18+",
    version: "ver:1.7.6(1J)",
    noticeContent: `🔥🔥🔥🔥 Super popular treasure box event, invite friends and win R$ 1,000,000. 🎉🎉 More bonuses on 688V, register now 🎁🎁\n`
},

sideNav: {
    treasure: "Treasure",
    magnata: "Tycoon",
    offers: "Offers",
    agent: "Agent",
    VIP: "VIP",
    rescue: "Rescue",
    mystrey: "Mystery",
    week: "Week",
    replacement: "Exchange",
    level: "Level"
},

socialMedia: {
    telegram: "Telegram",
    whatsapp: "WhatsApp",
    facebook: "Facebook",
    instagram: "Instagram",
    twitter: "Twitter",
    kwai: "Kwai",
    tiktok: "TikTok"
},

report: {
    directReport: "My Direct Subordinates",
    title: "User Effective Conditions",
    depositText: "Total Deposits",
    turnOver: "Game Bets",
    subordinate: "Subordinate",
    effective: "Effective",
    name: "Name",
    deposit: "Deposit",
    bets: "Bets"
},
activityName:{
    user_referral_reward: "Treasure",
    magnata: "Tycoon",
    recharge_bargain_sales: "Offers",
    agent_cash_back: "Agent",
    vip_reward: "VIP",
    rescue: "Rescue",
    mystery: "Mystery",
    week: "Week",
    replacement: "Exchange",
    user_rank: "Level",
    game_benefit: "Loss Relief Funds",
    first_recharge: "First Recharge",
    recharge_gift: "Recharge Automatic Gift",
    return_turnover: "Full-site code cleaning",
    pwa_reward: "PWA Rewards"
},
dayList: {
    giftAmount:"Gift Amount",
    turnoverTimes:"Tempos de rotatividade",
    refundRatio:"Refund Ratio"
},
activityStatus: {
    pending: "Pending",
    completed: "Completed",
    noRewards: "No Rewards"
},
pwaInstructions: {
    popupTitle: 'Click "Add to Home Screen" to save to your iPhone home screen',
    btnText: "Download APP"
},
activity: {
    available: "Available",
    given: "Given",
    total: "Total",
    today: "Today",
    click: "Click",
    bettingAmount: "Betting Amount",
    cashBackTotal: "Cashback Total",
    details: "Details",
    lossTotal:"Total loss",
    givenAmount: "Given Amount"
},
recharge:{
    CumulativeReachargeAmount:"Cumulative Reacharge Amount",
    giveAway: "Gift Amount",
    giftAmountText: "Recharge reward for each recharge:"
},
betting:{
    CumulativeBettingAmount:"Cumulative Betting Amount",
    giftAmountText: "Betting reward for each betting:"
},
commission:{
    recharge:"Recharge Commission",
    betting:"Betting Commission"
},
notice:{
    updateNotification: 'Update Notification',
    contentText: '<p>Dear User,</p><p>The system is currently undergoing an update.</p><p>Please try again later.</p><p>Operations Team www.688V.com</p>',
}
};
